import { IconPropsType } from './types/IconsProps.type';

type VirusIconProps = IconPropsType & {
  strokeColor?: string;
};

export const MedalIcon = ({
  width = 22,
  height = 26,
  className = '',
  style = {},
  fillColor = 'none',
  strokeColor = 'currentColor',
}: VirusIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 26"
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M8.62945 10.6785L10.4744 12.8473C10.5537 12.9405 10.6995 12.9412 10.7798 12.8489L19.212 3.14819M16.3168 4.25656C16.3168 4.25656 15.99 2.267 14.9856 1.84424C13.9687 1.41621 13.3618 2.65638 12.2568 2.59401C10.8874 2.51671 10.4711 0.753415 9.12862 1.02926C7.95942 1.26951 8.04002 2.63669 6.96553 3.14819C5.89409 3.65824 4.77557 2.67778 3.93719 3.50678C3.21596 4.21995 3.84783 5.12808 3.37146 6.0169C2.79463 7.09315 1.43822 7.00603 1.07525 8.16843C0.713629 9.32649 1.77469 9.98957 1.74081 11.2001C1.71076 12.2742 0.758365 12.8445 1.07525 13.8732C1.37524 14.8471 2.34802 14.8857 2.97212 15.6988C3.8422 16.8323 3.24361 18.3525 4.5362 18.9913C5.47606 19.4557 6.24401 18.6347 7.23175 18.9913C8.27685 19.3685 8.26078 20.6832 9.36157 20.8494C10.4991 21.0212 10.8847 19.7722 12.0238 19.6107C13.1699 19.4481 13.884 20.5049 14.9523 20.067C16.0763 19.6064 15.7871 18.3333 16.6828 17.5243C17.6743 16.6288 19.1931 17.1652 19.7444 15.9596C20.2283 14.9014 19.0394 14.1613 19.2785 13.0257C19.5254 11.8533 21.2214 11.623 20.9757 10.4504C20.7854 9.54205 19.5807 9.63396 19.2785 8.75521C18.9995 7.94363 19.7016 7.39903 19.4782 6.57108C19.3446 6.07569 18.8792 5.39752 18.8792 5.39752M12.4565 21.045L14.1804 24.8592C14.2539 25.0218 14.4929 25.0117 14.5518 24.8434L15.5222 22.071C15.557 21.9714 15.6661 21.9167 15.7689 21.9472L19.1312 22.9436C19.2942 22.9919 19.4401 22.8311 19.3721 22.6782L17.6146 18.7305M8.72928 22.1208L7.52148 24.8815C7.4514 25.0416 7.21863 25.0388 7.15256 24.877L6.00013 22.0548C5.9624 21.9624 5.85988 21.9125 5.76191 21.9388L2.56681 22.7974C2.40664 22.8405 2.26596 22.6843 2.32951 22.534L3.53785 19.6759M14.4532 6.2777C13.6323 5.70178 11.538 4.66079 9.72764 5.10414C7.4647 5.65832 6.06701 6.63628 5.20177 8.49441C4.33653 10.3526 4.43637 12.3737 5.20177 13.971C5.96717 15.5684 8.06373 16.6768 9.39486 16.9375C10.726 17.1983 13.1553 17.0027 14.7194 15.6988C15.9707 14.6556 16.6163 12.6345 16.7827 11.7543C16.8492 11.1458 16.8293 9.6419 16.2169 8.49441"
        stroke={strokeColor}
        strokeLinecap="round"
      />
    </svg>
  );
};
